import * as actionTypes from "./actionTypes";
import * as heatmapService from "./service";
import { applyFilter } from "../../utils/general";

const log = require("loglevel").getLogger("HeatmapActions");
log.setLevel("error");

export const loadHeatmapById = (id) => {
  return async (dispatch) => {
    log.debug("HeatmapActions -> loadHeatmapById -> Enter");

    const heatmap = await heatmapService.loadHeatmapById(id);

    await dispatch({
      type: actionTypes.HEATMAP_LOADED,
      data: heatmap,
    });
  };
};

export const loadHeatmapPicklists = () => {
  return async (dispatch) => {
    log.debug("HeatmapActions -> loadHeatmapPicklists -> Enter");

    const picklists = await heatmapService.loadHeatmapPicklists();

    await dispatch({
      type: actionTypes.HEATMAP_PICKLISTS_LOADED,
      data: picklists,
    });
  };
};

export const loadHeatmaps = (selectedFilters, forceReload) => {
  return async (dispatch) => {
    log.debug("HeatmapActions -> loadHeatmaps -> Enter");

    const result = await heatmapService.loadHeatmaps(
      selectedFilters,
      forceReload
    );

    const records = result?.data?.records ?? [];
    const lastUpdated = result?.data?.lastUpdated;

    let filteredHeatmaps = records;

    selectedFilters?.forEach((filter) => {
      filteredHeatmaps = applyFilter(filteredHeatmaps, filter);
    });

    await dispatch({
      type: actionTypes.HEATMAPS_LOADED,
      data: filteredHeatmaps,
      lastUpdated,
    });
  };
};

export const saveHeatmap = (heatmapId, updatedFields, selectedVendor, callback) => {
  return async (dispatch) => {
    log.debug("HeatmapActions -> saveHeatmap -> Enter");

    const result = await heatmapService.saveHeatmap(heatmapId, updatedFields, selectedVendor);
    await dispatch(loadHeatmapById(heatmapId));
    callback?.(result);
  };
};

export const createHeatmap = (updatedFields, callback) => {
  return async (dispatch) => {
    log.debug("HeatmapActions -> createHeatmap -> Enter");

    const result = await heatmapService.createHeatmap(updatedFields);
    callback?.(result);
  };
};
